export function setSales(state, sales) {
    state.sales = sales
}

export function setLoading(state, loading) {
  state.loading = loading
}




// WEBPACK FOOTER //
// ./src/reports-aggrid/modules/sales-budget/mutations.js